<script>
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';
	import countries from './countryList.json';

	let {
		form = null,
		style = '',
		error = '',
		name = 'country',
		label = 'Country',
		autocomplete = 'country-name',
		disabled = null,
		class: className = '',
		...props
	} = $props();
</script>

<SuperInput
	{form}
	class={className}
	options={countries}
	type="select"
	{name}
	{label}
	{style}
	{error}
	valueField="name"
	labelField="name"
	{autocomplete}
	{disabled}
	{...props}
/>
